import { render } from "./DataSourcesOnvifNext.vue?vue&type=template&id=a1082614&ts=true"
import script from "./DataSourcesOnvifNext.vue?vue&type=script&lang=ts"
export * from "./DataSourcesOnvifNext.vue?vue&type=script&lang=ts"

import "./DataSourcesOnvifNext.vue?vue&type=style&index=0&id=a1082614&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__